import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"height":"auto"} }
const _hoisted_2 = {
  key: 1,
  class: "body_content"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "total-unit_price-section"
}
const _hoisted_5 = { style: {"margin-top":"20px"} }
const _hoisted_6 = { style: {"text-align":"right","margin-top":"24px","margin-bottom":"20px"} }

import { ref, onMounted, computed, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  NDataTable,
  NSpace,
  NCard,
  NForm,
  NFormItem,
  NInput,
  NButton,
  NInputNumber,
  NDatePicker,
  NSelect,
  NRadioGroup,
  NRadio,
  NCheckboxGroup,
  NCheckbox,
  NGrid,
  NGi,
  FormInst,
  FormRules,
  NDescriptions,
  NDescriptionsItem,
  useMessage,
  useNotification,
  useDialog,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { getCallable } from "@/config/env";
import { useOrderForm, useOrderApi } from "@/composables/useOrderForm";
import { OrganizationType } from "@/model/organization"; // 추가
import { USER_ROUTES } from "@/assets/route_constants";
import * as common from "@/assets/common/common"; // 추가


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderEdit',
  setup(__props) {

const componentKey = ref(0);
const router = useRouter();
const route = useRoute();
const getCallApiCallable = getCallable("callApi");
const {
  pageLoading,
  submitLoading,
  requestFormRef,
  formModel,

  orgType,
  selectedOrgType,
  surveySet,
  coachSet,
  selectedCoachSKsForBoth,
  totalPrice,

  isUniversity,
  newFormRules,
  editFormRules,

  handleSubmitOrder,
  handleCancelEdit,
  setupForm,
} = useOrderForm({
  isEdit: true,
  orderSK: route.params.SK as string,
  cancelRouteName: USER_ROUTES.OrgOrder.Name,
  onSuccessNotificationTitle: "Order",
  onSuccessRedirect: USER_ROUTES.OrgOrder.Name,
  onErrorNotificationTitle: "견적서 수정 실패",
  submissionCallable: getCallApiCallable,
});
const { deleteOrder } = useOrderApi();
function deleteCurrentOrder(orderSK: string) {
  deleteOrder(orderSK).then((success) => {
    if (success) {
      router.push({ name: USER_ROUTES.OrgOrder.Name });
    }
  });
}
onMounted(async () => {
  await setupForm();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "main_div",
    key: componentKey.value
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(NSpace), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px","max-width":"1000px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                "item-style": "display: flex;",
                align: "center"
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createElementVNode("div", { style: {"font-size":"20px","width":"auto","font-weight":"bold"} }, " 견적서 수정 ", -1)
                ])),
                _: 1
              }),
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
              (_unref(pageLoading))
                ? (_openBlock(), _createBlock(Loading, { key: 0 }))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_unref(NForm), {
                      ref_key: "requestFormRef",
                      ref: requestFormRef,
                      model: _unref(formModel),
                      rules: _unref(editFormRules),
                      "label-placement": "left",
                      "require-mark-placement": "right-hanging"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NCard), {
                          title: "기본 정보",
                          style: {"margin-top":"20px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NDescriptions), {
                              "label-placement": "left",
                              column: 1,
                              size: "small",
                              bordered: "",
                              class: "org-info-descriptions"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NDescriptionsItem), { label: "견적명" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NFormItem), {
                                      path: "name",
                                      "show-label": false,
                                      style: {"margin-bottom":"0"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NInput), {
                                          value: _unref(formModel).name,
                                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formModel).name) = $event)),
                                          placeholder: "견적명"
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NCard), {
                          title: "기관 정보",
                          style: {"margin-top":"20px"}
                        }, {
                          default: _withCtx(() => [
                            (_unref(formModel).client)
                              ? (_openBlock(), _createBlock(_unref(NDescriptions), {
                                  key: 0,
                                  "label-placement": "left",
                                  column: 2,
                                  size: "small",
                                  bordered: "",
                                  class: "org-info-descriptions",
                                  style: {"margin-bottom":"10px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NDescriptionsItem), {
                                      label: "기관명",
                                      span: "2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(formModel).client.name || "N/A"), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(NDescriptionsItem), { label: "대표자 이름" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(formModel).client.president || "N/A"), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(NDescriptionsItem), { label: "기관 유형" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(common.getOrganizationTypeString(
                      _unref(formModel).client.type as OrganizationType
                    )), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(NDescriptionsItem), {
                                      label: "기관 주소",
                                      span: "2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(formModel).client.address.address || "") + " " + _toDisplayString(_unref(formModel).client.address.addressDetail || ""), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(NDescriptionsItem), { label: "담당부서명" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NFormItem), {
                                          path: "client.dept",
                                          "show-label": false,
                                          style: {"margin-bottom":"0"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(NInput), {
                                              value: _unref(formModel).client.dept,
                                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formModel).client.dept) = $event)),
                                              placeholder: "담당부서"
                                            }, null, 8, ["value"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(NDescriptionsItem), { label: "전화번호" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NFormItem), {
                                          path: "client.phoneNumber",
                                          "show-label": false,
                                          style: {"margin-bottom":"0"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(NInput), {
                                              value: _unref(formModel).client.phoneNumber,
                                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formModel).client.phoneNumber) = $event)),
                                              placeholder: "010-1234-5678"
                                            }, null, 8, ["value"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(NDescriptionsItem), { label: "담당자 성명" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NFormItem), {
                                          path: "client.deptPersonName",
                                          "show-label": false,
                                          style: {"margin-bottom":"0"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(NInput), {
                                              value: _unref(formModel).client.deptPersonName,
                                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formModel).client.deptPersonName) = $event)),
                                              placeholder: "담당자명"
                                            }, null, 8, ["value"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(NDescriptionsItem), { label: "핸드폰번호" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NFormItem), {
                                          path: "client.deptPersonPhoneNumber",
                                          "show-label": false,
                                          style: {"margin-bottom":"0"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(NInput), {
                                              value: _unref(formModel).client.deptPersonPhoneNumber,
                                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formModel).client.deptPersonPhoneNumber) = $event)),
                                              placeholder: "010-1234-5678"
                                            }, null, 8, ["value"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(NDescriptionsItem), {
                                      label: "이메일",
                                      span: "2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NFormItem), {
                                          path: "client.email",
                                          "show-label": false,
                                          style: {"margin-bottom":"0"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(NInput), {
                                              value: _unref(formModel).client.email,
                                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formModel).client.email) = $event)),
                                              placeholder: "contact@example.com"
                                            }, null, 8, ["value"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        (_unref(orgType) == _unref(OrganizationType).Etc)
                          ? (_openBlock(), _createBlock(_unref(NCard), {
                              key: 0,
                              title: "검사 대상 선택",
                              style: {"margin-top":"20px"},
                              "content-style": "text-align: left;"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NRadioGroup), {
                                  value: _unref(selectedOrgType),
                                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_isRef(selectedOrgType) ? (selectedOrgType).value = $event : null)),
                                  name: "orgTypeSelection"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NSpace), null, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createBlock(_unref(NRadio), {
                                          key: _unref(OrganizationType).ElementarySchool,
                                          value: _unref(OrganizationType).ElementarySchool,
                                          label: "초등학교"
                                        }, null, 8, ["value"])),
                                        (_openBlock(), _createBlock(_unref(NRadio), {
                                          key: _unref(OrganizationType).MiddleSchool,
                                          value: _unref(OrganizationType).MiddleSchool,
                                          label: "증학교"
                                        }, null, 8, ["value"])),
                                        (_openBlock(), _createBlock(_unref(NRadio), {
                                          key: _unref(OrganizationType).HighSchool,
                                          value: _unref(OrganizationType).HighSchool,
                                          label: "고등학교"
                                        }, null, 8, ["value"])),
                                        (_openBlock(), _createBlock(_unref(NRadio), {
                                          key: _unref(OrganizationType).University,
                                          value: _unref(OrganizationType).University,
                                          label: "대학교"
                                        }, null, 8, ["value"]))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(NCard), {
                          title: "검사 종류 선택",
                          style: {"margin-top":"20px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "selectedSurveySK",
                              "label-placement": "left"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NRadioGroup), {
                                  value: _unref(formModel).selectedSurveySK,
                                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formModel).selectedSurveySK) = $event)),
                                  name: "surveySelection"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NSpace), null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(surveySet), (survey) => {
                                          return (_openBlock(), _createBlock(_unref(NRadio), {
                                            key: survey.SK,
                                            value: survey.SK!,
                                            label: survey.name
                                          }, null, 8, ["value", "label"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_unref(formModel).selectedSurveySK)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createVNode(_unref(NCard), {
                                title: "코칭 상품 선택 (다중 선택 가능)",
                                style: {"margin-top":"20px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NCheckboxGroup), {
                                    value: _unref(selectedCoachSKsForBoth),
                                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_isRef(selectedCoachSKsForBoth) ? (selectedCoachSKsForBoth).value = $event : null))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NSpace), { "item-style": "display: flex;" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(coachSet), (coach) => {
                                            return (_openBlock(), _createBlock(_unref(NCheckbox), {
                                              key: coach.SK,
                                              value: coach.SK!,
                                              label: coach.name
                                            }, null, 8, ["value", "label"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(NCard), {
                          title: "신청 상품 및 수량",
                          style: {"margin-top":"20px"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formModel).products, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.prod_id,
                                class: "product-request-item"
                              }, [
                                _createVNode(_unref(NDescriptions), {
                                  title: item.name,
                                  "label-placement": "left",
                                  column: 3,
                                  size: "small",
                                  bordered: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_unref(isUniversity)(item))
                                      ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                                          key: 0,
                                          label: "학과",
                                          "label-placement": "left",
                                          style: {"text-align":"right"},
                                          labelStyle: "width:100px"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(NInput), {
                                              value: item.major,
                                              "onUpdate:value": ($event: any) => ((item.major) = $event),
                                              placeholder: "학과"
                                            }, null, 8, ["value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true),
                                    _createVNode(_unref(NDescriptionsItem), {
                                      label: "학년",
                                      "label-placement": "left",
                                      style: {"text-align":"right"},
                                      labelStyle: "width:100px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NInput), {
                                          value: item.grade,
                                          "onUpdate:value": ($event: any) => ((item.grade) = $event),
                                          placeholder: "학년"
                                        }, null, 8, ["value", "onUpdate:value"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (!_unref(isUniversity)(item))
                                      ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                                          key: 1,
                                          label: "학급수",
                                          "label-placement": "left",
                                          labelStyle: "width:100px"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(NInput), {
                                              value: item.class_num,
                                              "onUpdate:value": ($event: any) => ((item.class_num) = $event),
                                              placeholder: "학급수"
                                            }, null, 8, ["value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true),
                                    _createVNode(_unref(NDescriptionsItem), {
                                      label: "",
                                      "label-placement": "left",
                                      labelStyle: "width:100px"
                                    }, {
                                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                                        _createTextVNode("   ")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_unref(NDescriptionsItem), {
                                      label: "단가(원)",
                                      contentStyle: "text-align: right",
                                      path: `products[${index}].unit_price`,
                                      rule: _unref(editFormRules).unitPriceRule
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NInputNumber), {
                                          value: item.unit_price,
                                          "onUpdate:value": ($event: any) => ((item.unit_price) = $event),
                                          placeholder: "단가",
                                          "show-button": false,
                                          min: 0
                                        }, null, 8, ["value", "onUpdate:value"])
                                      ]),
                                      _: 2
                                    }, 1032, ["path", "rule"]),
                                    _cache[15] || (_cache[15] = _createTextVNode(" :rule=\"editFormRules.unitPriceRule\" ")),
                                    _createVNode(_unref(NDescriptionsItem), {
                                      path: `products[${index}].quantity`,
                                      rule: _unref(editFormRules).quantityRule,
                                      label: "총인원수"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NInputNumber), {
                                          value: item.quantity,
                                          "onUpdate:value": ($event: any) => ((item.quantity) = $event),
                                          placeholder: "수량",
                                          min: 1
                                        }, null, 8, ["value", "onUpdate:value"])
                                      ]),
                                      _: 2
                                    }, 1032, ["path", "rule"]),
                                    _createVNode(_unref(NDescriptionsItem), {
                                      label: "금액(원)",
                                      contentStyle: "text-align: right"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(common.formatNumberWithCommas(
                          Number(item.unit_price) * item.quantity
                        )), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["title"])
                              ]))
                            }), 128)),
                            (_unref(formModel).products.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  _createVNode(_unref(NGrid), {
                                    cols: 12,
                                    "x-gap": 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NGi), { span: 7 }),
                                      _createVNode(_unref(NGi), {
                                        span: 5,
                                        style: {"text-align":"right","font-weight":"bold","font-size":"1.1em"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" 총 결제 금액: " + _toDisplayString(common.formatNumberWithCommas(_unref(totalPrice))) + "원 ", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_unref(NGrid), {
                                cols: 12,
                                "x-gap": 12
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NGi), { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NFormItem), {
                                        label: "검사 실시 예정일",
                                        path: "test_due_date"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(NDatePicker), {
                                            "formatted-value": _unref(formModel).test_due_date,
                                            "onUpdate:formattedValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(formModel).test_due_date) = $event)),
                                            "value-format": "yyyy-MM-dd",
                                            type: "date",
                                            placeholder: "검사 실시 예정일 선택",
                                            style: {"width":"200px"}
                                          }, null, 8, ["formatted-value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(NGi), {
                                    span: 12,
                                    style: {"padding-top":"5px"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_unref(selectedCoachSKsForBoth).length > 0)
                                        ? (_openBlock(), _createBlock(_unref(NFormItem), {
                                            key: 0,
                                            label: "상담 코칭 예정일",
                                            path: "coaching_due_date"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(NDatePicker), {
                                                "formatted-value": _unref(formModel).coaching_due_date,
                                                "onUpdate:formattedValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(formModel).coaching_due_date) = $event)),
                                                "value-format": "yyyy-MM-dd",
                                                type: "date",
                                                placeholder: "상담 코칭 예정일 선택",
                                                style: {"width":"200px"}
                                              }, null, 8, ["formatted-value"]),
                                              _cache[16] || (_cache[16] = _createElementVNode("span", { style: {"margin-left":"10px","color":"red"} }, "(일정은 검사 완료 및 결과리포트를 수령, 확인 후이어야 함. 042-867-5558)", -1))
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NCard), {
                          title: "결제 정보",
                          style: {"margin-top":"20px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NDescriptions), {
                              "label-placement": "left",
                              column: 2,
                              size: "small",
                              bordered: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NDescriptionsItem), {
                                  label: "결제계좌",
                                  "label-placement": "left",
                                  style: {"text-align":"right"},
                                  labelStyle: "width:100px;",
                                  contentStyle: "text-align: center; ;align-content: center;"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(formModel).payment_method.bank_name || "N/A"), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(NDescriptionsItem), {
                                  label: "입금예정일",
                                  "label-placement": "left",
                                  labelStyle: "width:100px"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NFormItem), {
                                      path: "payment_method.bank_date",
                                      "show-label": false,
                                      style: {"margin-bottom":"0"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NDatePicker), {
                                          "formatted-value": 
                          _unref(formModel).payment_method.bank_date
                        ,
                                          "onUpdate:formattedValue": _cache[11] || (_cache[11] = ($event: any) => ((
                          _unref(formModel).payment_method.bank_date
                        ) = $event)),
                                          "value-format": "yyyy-MM-dd",
                                          type: "date",
                                          placeholder: "입금 예정일 선택",
                                          style: {"width":"100%"}
                                        }, null, 8, ["formatted-value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_unref(NButton), {
                            type: "tertiary",
                            onClick: _unref(handleCancelEdit),
                            style: {"margin-right":"12px"}
                          }, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createTextVNode(" 취소하기 ")
                            ])),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_unref(NButton), {
                            type: "primary",
                            onClick: _unref(handleSubmitOrder),
                            loading: _unref(submitLoading),
                            style: {"min-width":"150px"}
                          }, {
                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                              _createTextVNode(" 견적서 수정하기 ")
                            ])),
                            _: 1
                          }, 8, ["onClick", "loading"]),
                          _createVNode(_unref(NButton), {
                            type: "error",
                            ghost: "",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (deleteCurrentOrder(_unref(formModel).SK))),
                            disabled: !_unref(formModel).SK,
                            style: {"margin-left":"12px"}
                          }, {
                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                              _createTextVNode(" 견적 삭제 ")
                            ])),
                            _: 1
                          }, 8, ["disabled"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})